import changelog from "../../../../../pages/offers/docs/changelog-offers.json5";
import * as React from 'react';
export default {
  changelog,
  React
};